import React from 'react';
import './style.scss';

const Banner = () => {
    return (
        <div className='banner bc-color'>
            <div className='banner-titles GlobalWrapper'>
                <h1 className='banner-titles__title'>Bepul shifokor maslahat kerakmi?</h1>
                <p className='banner-titles__text'>24/7 video maslahat. Shaxsiy maslahat + Audio qo'ng'iroq</p>
                <p className='banner-titles__text'>Faqat <span>mobil ilovada</span></p>
            </div>
        </div>
    );
}

export default Banner;
